import $ from 'jquery'
import 'jquery.nicescroll'
import EmblaCarousel from "embla-carousel";
import pop from '../pop.js'

let $desc = null

const limitContentHeight = () =>{
    $desc.css({'maxHeight':100000})
    let height = $desc.outerHeight();
    let lineHeight = parseFloat($desc.css('lineHeight'))
    let line = Math.floor(height/lineHeight);
    if(line > 7 && $('body').width() > 768 ){
        line = line - 2
    }else if($('body').width() <= 768){
        line = line - 1
    }
    $desc.css({'maxHeight': line * lineHeight})
    $desc.getNiceScroll().resize();
}


let showPop = (index = 0) => {
    
    let $p = pop.show($('.section-initiatives > .pops > .pop-wrap-initiatives').eq(index).clone());
    $desc = $('.pop-wrap-bg .pop-wrap-initiatives .pop-container .left .desc')
    let im = $('.pop-wrap-bg .pop-wrap-initiatives .pop-container .right .slider:eq(0) > img').attr('src')
    $desc.before(`<div class="mobile" style="background-image: url(${im});"></div>`);

    limitContentHeight()
    $desc.niceScroll({touchbehavior:true,cursorwidth: "0px",cursorborder:'none',grabcursorenabled: false});

    // if(false){
    let $mobile = $('.pop-wrap-bg .pop-wrap-initiatives .pop-container .mobile:visible')
    if($mobile.length ){

        // $desc.niceScroll({touchbehavior:true,cursorwidth: "0px",cursorborder:'none',grabcursorenabled: false})
        
        
        let $right = $('.pop-wrap-bg .pop-wrap-initiatives .pop-container .right')
        // $('.pop-wrap-bg .pop-wrap-initiatives .pop-container .right').addClass('show')
        $mobile.click(()=>{
            $right.addClass('show')
            if(true != $right.data('init')){
                $right.data('init',true)
                $right.append('<a href="#" class="iconfont">&#xe651;</a>')
                $right.children('a.iconfont').click(()=>{
                    $right.removeClass('show')
                })
                EmblaCarousel($p.find(".embla > .viewport")[0], { loop: true, skipSnaps: false })
                let $sliders = $right.find('.container > .slider')
                let counts = $sliders.length
                if(counts > 1){
                    $.each($sliders, (i,e) => {
                        $(e).append(`<div class="page"><span>${i+1}</span><span>${counts}</span></div`)
                    })
                }
            }
        })
        
    }else{
        let $dots = $('body > .pop-wrap-bg > .pop-wrap-initiatives  .thumbnail-wrap .thumbnails img')
        let $sliders = $('body > .pop-wrap-bg > .pop-wrap-initiatives .embla .slider')

        let $npBtnWrap = $('body > .pop-wrap-bg > .pop-wrap-initiatives  .thumbnail-wrap');
        let $imgWrap = $npBtnWrap.find('.box > .thumbnails')
        let imgLength = $dots.length;
        let imgIndex = 0
        let groupIndex = 0;
        let unitNumber = 4;
        // let groupCount = Math.ceil(imgLength / unitNumber);
        let imgSpaceWidth = 0;
        let allowClick = true;

        $imgWrap.children('img').eq(imgIndex).addClass('active')
        $sliders.eq(imgIndex).css({opacity:1,zIndex:2})

        const npWidth = () => {
            let width = 0;
            $imgWrap.css('width','100%')
            imgSpaceWidth = 44 / 3 / 820 * $npBtnWrap.width();
            for (let i = 0; i < imgLength; i++) {
                let pl = (i == 0)? 0 : imgSpaceWidth
                let $im = $imgWrap.children('img').eq(i);
                if(pl){
                    $im.css('marginLeft',pl);
                }
                width +=  pl + $im.width()+2
            }
            if(groupIndex){
                $imgWrap.css({'width':width,left: `-${groupIndex*100}%`,'marginLeft': `-${imgSpaceWidth}`})
            }else{
                $imgWrap.css({'width':width})
            }
            $imgWrap.css({'width':width,left: `-${groupIndex*100}%`})
        }
        const changeIm = next => {
            if(next != imgIndex){
                let timee = 500
                allowClick = false
                // $sliders.removeClass('active').eq(next).addClass('active')
                $imgWrap.children('img').eq(imgIndex).animate({'opacity':0.4},timee)
                $imgWrap.children('img').eq(next).animate({'opacity':1},timee)
                $sliders.eq(imgIndex).animate({'opacity':0,'zIndex':1},timee/2)
                $sliders.eq(next).animate({'opacity':1,'zIndex':2},timee,()=>{
                    // $dots.removeClass('active').eq(next).addClass('active')
                    imgIndex = next
                    allowClick = true
                    $imgWrap.children('img').removeClass('active').eq(next).addClass('active')
                    $npBtnWrap.children('.iconfont').removeClass('active')
                    if(imgIndex > 0 ){
                        $npBtnWrap.children('.iconfont.prev').addClass('active')
                    }
                    if(imgIndex < imgLength - 1){
                        $npBtnWrap.children('.iconfont.next').addClass('active')
                    }
                })
                let _gIndex = Math.ceil((next+1) / unitNumber) -1
                if(_gIndex != groupIndex){
                    groupIndex = _gIndex
                    if(_gIndex == 0){
                        $imgWrap.animate({'left':0},timee)
                    }else{
                        $imgWrap.animate({left: `-${_gIndex*100}%`,'marginLeft': `-${imgSpaceWidth}`},timee)
                    }
                    
                }
                
            }
        }
        const npShow = () => {
            if(imgLength > unitNumber){
                $npBtnWrap.children('.iconfont.next').addClass('active')
                $npBtnWrap.children('.iconfont').css('display','flex').click(function(){
                    if($(this).is('.active') && allowClick){
                        if($(this).is('.next')){
                            changeIm(imgIndex+1)
                        }else{
                            changeIm(imgIndex-1)
                        }
                    }
                })
            }else{
                $npBtnWrap.children('.iconfont').css('display','none')
            }
            $imgWrap.children('img').click(function(){
                if(allowClick){
                    changeIm($imgWrap.children('img').index($(this)))
                }
                
            })
        }
        npWidth()
        npShow();
        $(window).resize(()=>{
            npWidth()
        })
    }
}


export default {
    init(){
        $(()=>{
            
            let $sliders = $('.section-initiatives > .embla-wrap .slider')
            let $dots = $('.section-initiatives > .embla-wrap .dots > span')
            let count = $sliders.length
            let allowClick = true
            if(count > 0){
                $('.section-initiatives > .embla-wrap .slider > .view').click(()=>{
                    if(allowClick){
                        showPop($dots.index($('.section-initiatives > .embla-wrap .dots > span.active')))
                    }
                })
                if(count > 1){
                    $sliders.eq($dots.index($('.section-initiatives > .embla-wrap .dots > span.active'))).addClass('active')
                    let timee = 1000
                    $dots.click(function(){
                        if(!$(this).is('.active') && allowClick){
                            allowClick = false
                            let next = $dots.index($(this));
                            let index = $dots.index($('.section-initiatives > .embla-wrap .dots > span.active'))
                            $dots.eq(index).animate({'opacity':0.4},timee)
                            $dots.eq(next).animate({'opacity':1},timee)
                            $sliders.eq(index).children('.title,.view').hide();
                            $sliders.eq(next).children('.title,.view').hide();
                            $sliders.eq(index).animate({'opacity':0,'zIndex':1},timee/2,()=>{
                                $sliders.eq(next).children('.title,.view').show();
                                $dots.removeClass('active').eq(next).addClass('active')
                                $sliders.removeClass('active').eq(next).addClass('active')
                                allowClick = true
                            })
                            $sliders.eq(next).animate({'opacity':1,'zIndex':2},timee)
                        }
                    })
                }else{
                    $sliders.eq(0).addClass('active')
                }
            }

            // showPop(0)
        })
    }
}